/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { NgClass } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
	selector: "globalictcc-spinner",
	standalone: true,
	imports: [NgClass],
	templateUrl: "./spinner.component.html",
	styleUrl: "./spinner.component.scss"
})
export class SpinnerComponent {
	@Input() public size: "small" | "large" = "small";
}
